import React from "react";
import moment from "moment-timezone";
import "react-datepicker/dist/react-datepicker.css";

const DatePicker = require("react-datepicker").default;

const PERM_STRING = "2222-02-02";
const PERM = moment(PERM_STRING);
const DAYS_IN_AIRAC_CYCLE = 28;
const DATE_TIME_FORMAT = "YYYY-MM-DDTHH:mm:ss.SSS";

const setLocalZone = (date: Date, timezone: string) => {
    const dateWithoutZone = moment.tz(date, timezone).format(DATE_TIME_FORMAT);
    const localZone = moment(dateWithoutZone).format("Z");
    const dateWithLocalZone = [dateWithoutZone, localZone].join("");

    return new Date(dateWithLocalZone);
};

const setOtherZone = (date: Date, timezone: string) => {
    const dateWithoutZone = moment(date).format(DATE_TIME_FORMAT);
    const otherZone = moment.tz(date, timezone).format("Z");
    const dateWithOtherZone = [dateWithoutZone, otherZone].join("");

    return new Date(dateWithOtherZone);
};

const airacDates = () => {
    const daysHighlighted: Date[] = [];
    const firstAiracDate = moment("2009-01-15");
    while (daysHighlighted.length === 0 || daysHighlighted[daysHighlighted.length - 1] < PERM.toDate()) {
        daysHighlighted.push(firstAiracDate.add(DAYS_IN_AIRAC_CYCLE, "days").toDate());
    }
    return daysHighlighted;
};

interface AeroDatePickerProps {
    className: string;
    id: string;
    disabled: boolean;
    selectedDate: Date;
    onDateChange: (date: Date) => void;
    timezone: string;
    highlightAiracDates: boolean;
    dateFormat: string;
}

export const AeroDatePicker = (props: AeroDatePickerProps) => {
    const { dateFormat, onDateChange, selectedDate, highlightAiracDates, timezone } = props;
    return (
        <>
            <DatePicker
                selected={selectedDate ? setLocalZone(selectedDate, timezone) : new Date()}
                onChange={(value: Date) => {
                    onDateChange(setOtherZone(value, timezone));
                }}
                highlightDates={highlightAiracDates ? [{ highlightedDate: airacDates() }] : []}
                showYearDropdown={true}
                showMonthDropdown={true}
                dropdownMode={"select"}
                {...props}
                dateFormat={dateFormat}
            />
        </>
    );
};
